import { Button, SxProps, Theme } from '@mui/material';

interface SecondaryActionButtonProps {
  actionText: string;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  sx?: SxProps<Theme>;
  type?: 'button' | 'submit' | 'reset';
}

export function SecondaryActionButton(props: SecondaryActionButtonProps) {
  const { actionText, onClick, sx, type } = props;

  return (
    <Button sx={sx} variant='contained' color='secondary' onClick={onClick} type={type}>
      {actionText}
    </Button>
  );
}
